module.exports = __webpack_public_path__ + "img/c2.54c985ea.png";